import { render, staticRenderFns } from "./TicketCreation.vue?vue&type=template&id=256eb5c0&scoped=true"
import script from "./TicketCreation.vue?vue&type=script&lang=js"
export * from "./TicketCreation.vue?vue&type=script&lang=js"
import style0 from "./TicketCreation.vue?vue&type=style&index=0&id=256eb5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256eb5c0",
  null
  
)

export default component.exports